import { render, staticRenderFns } from "./PersonContactRow.vue?vue&type=template&id=7ac5848a&"
import script from "./PersonContactRow.vue?vue&type=script&lang=js&"
export * from "./PersonContactRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports